import React from 'react';
import './ProfileDataItem.scss';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { ReactComponent as EditIcon } from 'style/icons/edit.svg';
import { Button } from 'components/form/Button/Button';

export const SaveCancelButtons = ({
  datatestid,
  onCancelHandle,
  onSaveHandle,
  disabled,
  ...props
}) => {
  const saveButtonTxt = props.customButtonText
    ? props.customButtonText
    : 'Save';
  return (
    <FlexContainer className="justify-end margT8 flex-mobile-col mobile-justify-center">
      <Button
        datatestid={datatestid ? `${datatestid}-cancel` : null}
        mrphType="standard"
        onClick={onCancelHandle}
      >
        Cancel
      </Button>
      <div style={{ padding: 6 }}></div>
      <Button
        datatestid={datatestid ? `${datatestid}-submit` : null}
        mrphType="primary"
        onClick={onSaveHandle}
        disabled={disabled}
      >
        {saveButtonTxt}
      </Button>
    </FlexContainer>
  );
};

export const EditValue = ({ datatestid, editHandle }) => {
  return (
    <div
      className="EditValue"
      data-testid={datatestid ? `${datatestid}` : null}
    >
      <Label
        type="Subtitle-2"
        color="fontBlue100"
        className="mobileHide pointer margL4 editText secondary_text_light"
        datatestid={datatestid ? `${datatestid}-editLink` : null}
        onClick={editHandle}
      >
        Edit
      </Label>
      <div className="editLogo pointer desktopHide" onClick={editHandle}>
        <EditIcon />
      </div>
    </div>
  );
};

export const AddValue = ({ datatestid, setIsEdit, label }) => {
  return (
    <Label
      type="Subtitle-2"
      color="secondary_text_light"
      className="pointer"
      datatestid={datatestid ? `${datatestid}-addLink` : null}
      onClick={() => {
        setIsEdit(true);
      }}
    >
      + Add {label}
    </Label>
  );
};

export const ProfileDataItem = ({
  label,
  children,
  datatestid,
  classNameOverwrites,
  ...props
}) => {
  let finalClassName = classNameOverwrites
    ? classNameOverwrites
    : 'ProfileDataItem flex-mobile-col justify-between padT16 padB16 borderTp borderColorGray025 pos-rel';
  return <FlexContainer className={finalClassName}>{children}</FlexContainer>;
};

ProfileDataItem.Title = ({
  icon: Icon,
  children,
  datatestid,
  labelType,
  ...props
}) => {
  let desktopLabelType = 'H5';
  let mobileLabelType = 'Subtitle-1';
  if (labelType) {
    desktopLabelType = labelType.desktopLabelType;
    mobileLabelType = labelType.mobileLabelType;
  }

  return (
    <FlexContainer
      className="DataItem-Title format50 m-format100"
      datatestid={datatestid}
    >
      {Icon && (
        <Icon
          className="icon"
          data-testid={datatestid ? `${datatestid}-icon` : null}
        />
      )}
      <Label type={desktopLabelType} className="mobileHide">
        {children}
      </Label>
      <Label type={mobileLabelType} className="desktopHide margB12">
        {children}
      </Label>
    </FlexContainer>
  );
};

ProfileDataItem.DisplayView = ({
  datatestid,
  editHandle,
  editEnabled,
  classNameOverwrites,
  ...props
}) => {
  const style =
    classNameOverwrites && classNameOverwrites.view
      ? classNameOverwrites.view
      : 'DisplayView format50 m-format100';
  return (
    <>
      <div data-testid={datatestid ? datatestid : null} className={style}>
        {props.children}
      </div>
      {editEnabled ? (
        <EditValue
          datatestid={datatestid ? `${datatestid}-editIcon` : null}
          editHandle={editHandle}
        />
      ) : (
        ''
      )}
    </>
  );
};

ProfileDataItem.EditView = ({
  datatestid,
  onSaveHandle,
  disabled,
  onCancelHandle,
  hideButtons,
  classNameOverwrites,
  ...props
}) => {
  let editViewClassName =
    classNameOverwrites && classNameOverwrites.editView
      ? classNameOverwrites.editView
      : 'EditView format50 flex-column m-format100';
  return (
    <FlexContainer
      datatestid={datatestid ? datatestid : null}
      className={editViewClassName}
    >
      {props.children}
      {!hideButtons && (
        <SaveCancelButtons
          datatestid={datatestid ? `${datatestid}-actionBtns` : null}
          onSaveHandle={onSaveHandle}
          onCancelHandle={onCancelHandle}
          disabled={disabled}
          {...props}
        />
      )}
    </FlexContainer>
  );
};
